module.exports = __webpack_public_path__ + "eco-icon.09c99331ddd763205a9d864bff551da7.svg";